import type { EmbedSearchWidgetLayoutHandleProps } from 'modules/embedSearchWidget/layouts/layout/EmbedSearchWidgetLayoutHandleProps';
import type { embedSearchWidgetViewVolopRoute } from 'modules/embedSearchWidget/routing/embedSearchWidget.routes';
import { listingApiHorizonFetchVolop } from 'modules/listing/api/volop/listingApiHorizonFetchVolop';
import { SearchVolopsRefinements } from 'modules/search/pages/Volops/components/SearchVolopsRefinements';
import { NotFoundPageLoadable } from 'pages/NotFound/NotFoundPageLoadable';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { EmbedSearchWidgetViewVolopPageLoadable } from './EmbedSearchWidgetViewVolopPageLoadable';

export const handle = {
  searchRefinements: <SearchVolopsRefinements />,
  defaultSearchType: 'VOLOP',
} satisfies EmbedSearchWidgetLayoutHandleProps;

export async function loader({
  request,
  context,
  params: { volopId },
}: HorizonAppRouteLoaderArgs<typeof embedSearchWidgetViewVolopRoute>) {
  try {
    const [volop] = await Promise.all([
      listingApiHorizonFetchVolop({ request, context })(volopId),
      EmbedSearchWidgetViewVolopPageLoadable.load(),
    ]);

    return { volop };
  } catch {
    return { volop: null };
  }
}

export default function EmbedSearchWidgetViewVolopHorizonRoute({
  loaderData: { volop },
}: HorizonAppRouteComponentProps<typeof loader>) {
  if (!volop || volop.type !== 'VOLOP') return <NotFoundPageLoadable />;

  return <EmbedSearchWidgetViewVolopPageLoadable volop={volop} />;
}
